<template>
  <div class="main">
    <CurrentLocation v-bind:active="useGps" ref="currentLocation"/>
    <AddressesFilter v-if="showFilter"
                     v-model="adrFilter"
                     :addresses="addresses"
                     :disabled="loadingState !== LoadingState.COMPLETED"/>
    <!-- 読み込みエラー表示 -->
    <div v-if="loadingState === LoadingState.FAILED"
         style="text-align:center; margin: 1em;">
      住所一覧を読み込めませんでした<br/>
      <v-btn v-on:click="loadAddresses()">再読み込み</v-btn>
    </div>

    <div
      v-if="loadingState === LoadingState.COMPLETED && $refs.currentLocation.progress && filteredAddresses.length === 0"
      style="width:100%; height:100%; position:absolute; z-index:10; align-items:center; display:flex; justify-content:center">
      <div>
        現在位置を取得しています...
      </div>
    </div>

    <!-- 読み込み中表示 -->
    <LoadingOverlay v-if="loadingState === LoadingState.LOADING"/>

    <!-- 住所一覧表示 -->
    <div v-if="loadingState === LoadingState.COMPLETED">
      <v-list>
        <template v-for="item in filteredAddresses">
          <v-list-tile :key="item.id" target="_blank"
                       :href="`https://maps.google.com/maps?q=${item.location[0]},${item.location[1]}`">
            <v-list-tile-content class="address">{{ item.adr1 }} {{ item.adr2 }} {{item.name }}</v-list-tile-content>
            <v-list-tile-action-text class="distance">{{ item.distance ? distanceText(item.distance) : '' }}
            </v-list-tile-action-text>
          </v-list-tile>
        </template>
      </v-list>
    </div>
  </div>
</template>

<script>
// import AddressList from './AddressList'
import api from '@/lib/api'
import {getAuthToken, sessionTimeouted, distanceText} from '@/lib/common'
import LoadingOverlay from '@/components/LoadingOverlay'
import CurrentLocation from '@/components/CurrentLocation'
import AddressesFilter from '@/components/AddressesFilter'

const geo = require('geolib')

export const LoadingState = Object.freeze({
  IDLE: Symbol('idle'),
  LOADING: Symbol('loading'),
  FAILED: Symbol('failed'),
  COMPLETED: Symbol('completed')
})

export default {
  name: 'MainList',
  props: {
    useGps: false,
    showFilter: false
  },
  data () {
    return {
      // ユーザーが手入力したアドレス
      address: '',
      // 検索対象のアドレス一覧
      addresses: [],
      adrFilter: {adr1: '', adr2: ''},
      loadingState: LoadingState.IDLE,
      LoadingState: LoadingState,
      timerId: null
    }
  },
  components: {AddressesFilter, LoadingOverlay, CurrentLocation},
  created: function () {
    console.log('MainList.created')
    this.loadAddresses()
  },
  destroyed: function () {
    console.log('MainList.destroyed')
  },
  methods: {
    // 住所一覧を読み込み
    loadAddresses: function () {
      this.loadingState = LoadingState.LOADING
      console.log('住所一覧を読み込み開始')
      api.getAddresses(getAuthToken()).then((response) => {
        console.log(`住所一覧を読み込み完了 count: ${response.data.addresses.length}`)
        this.addresses = response.data.addresses.map(a => ({
          name: a[2],
          adr1: a[0],
          adr2: a[1],
          location: [parseFloat(a[3]), parseFloat(a[4])]
        }))
        this.loadingState = LoadingState.COMPLETED
      }).catch((error) => {
        this.loadingState = LoadingState.FAILED
        console.log(`住所一覧の読み込み失敗: ${error.message}`)
        if (error.response) {
          if (error.response.status === 401) {
            sessionTimeouted(this)
          }
        }
      })
    },
    distanceText: distanceText
  },
  computed: {
    filteredAddresses: function () {
      console.log('filteredAddresses')
      let addresses = this.addresses.slice()

      addresses.map((a, index) => {
        a.id = index
      })
      if (this.showFilter) {
        const filter = this.adrFilter
        if (filter) {
          if (filter.adr1) {
            addresses = addresses.filter(a => a.adr1 === filter.adr1)
          }
          if (filter.adr2) {
            addresses = addresses.filter(a => a.adr2 === filter.adr2)
          }
        }
      } else {
        const loc = this.$refs.currentLocation.location
        if (loc) {
          addresses.map((a) => {
            a.distance = geo.getDistance(
              {latitude: loc[0], longitude: loc[1]},
              {latitude: a.location[0], longitude: a.location[1]})
          })
          addresses = addresses.sort((a, b) => a.distance - b.distance).splice(0, 30)
        } else {
          addresses = []
        }
      }
      return addresses
    }
  }
}
</script>

<style scoped lang="scss">
  .main {
    height: 100%;
    position: relative;
  }

  .address {
    text-overflow: ellipsis;
    font-size: small;
    margin-top: 4px;
    margin-bottom: 4px;
  }

  .distance {
    white-space: nowrap;
    margin-left: 1em;
    font-size: small;
  }
</style>

<style>
  .v-list__tile {
    height: auto;
    min-height: 48px;
  }
</style>



// WEBPACK FOOTER //
// src/components/MainList.vue